import type { FieldProps } from '@rjsf/utils';
import { getDisplayLabel } from '@rjsf/utils';
import { forwardRef } from 'react';
import { useLanguageSafe } from '../../context/LanguageContext';
import Translation, { TranslationData } from '../../form-elements/Translation';

const TranslationField = forwardRef<HTMLDivElement, FieldProps<TranslationData>>((props, ref) => {
  const {
    formData,
    onChange,
    schema,
    onFocus,
    fieldPathId: { path },
    label,
    required,
    name,
    registry,
    uiSchema,
  } = props;

  // Get selected language to force re-render when it changes
  const languageContext = useLanguageSafe();
  const selectedLanguage = languageContext?.selectedLanguage || 'en';

  // Get the display label using RJSF's utility, which handles ui:title and schema.title properly
  const displayLabel = getDisplayLabel(schema, uiSchema, registry?.rootSchema);
  // Check uiSchema for title override, then use displayLabel, then schema.title, then name
  const title =
    (uiSchema && 'ui:title' in uiSchema && uiSchema['ui:title'] !== false
      ? typeof uiSchema['ui:title'] === 'string'
        ? uiSchema['ui:title']
        : null
      : null) ||
    label ||
    displayLabel ||
    schema.title ||
    name;
  const description =
    (uiSchema && 'ui:description' in uiSchema
      ? typeof uiSchema['ui:description'] === 'string'
        ? uiSchema['ui:description']
        : null
      : null) || schema.description;

  return (
    <div ref={ref} key={`translation-field-${path}-${selectedLanguage}`}>
      <Translation
        onFocus={(id, value) => onFocus?.(id, value)}
        id={path.join('.')}
        value={formData}
        title={title}
        description={description}
        required={required}
        onChange={(value) => onChange(value, path)}
      />
    </div>
  );
});

TranslationField.displayName = 'TranslationField';

export default TranslationField;
